// extracted by mini-css-extract-plugin
export var black = "_3c-6";
export var brand = "_3c-1";
export var ddefault = "_3c-0";
export var error = "_3c-3";
export var gray = "_3c-2";
export var highContrast = "_3c-8";
export var outline = "_3c-7";
export var success = "_3c-5";
export var warning = "_3c-4";